"use client"

import React from "react"
import styled from "styled-components"
import { blockPadding, blockStyles, common } from "../common/_atoms"

const FooterSection = ({ children, ...rest }) => {
  return (
    <Wrapper className="background" {...rest}>
      {children}
    </Wrapper>
  )
}

export default FooterSection

const Wrapper = styled.div`
  ${blockStyles};
  ${blockPadding};
  ${common};
  margin-top: 0;
  margin-bottom: 0;

  > div:first-of-type {
    margin-top: 0 !important;
  }

  > div:last-of-type {
    margin-bottom: 0 !important;
  }
`
